export default {
  customerList: {},
  orderDetail: {},
  historyOrderList: {},
  reportList: {},
  isCheckAll: false,
  hasChecked: false,
  hasDeleteItem: true,
  timeKeepingList: {},
  payrollData: {},
  payrollSetting: {},
  discountSetting: {},
  cashDiscountSetting: {},
  incomeDetail: {},
  approvePayrollData: [],
  salaryChartData: {},
  calculatedOrder: {},
  checkedGiftCardData: {},
  salaryDetail: null,

  //ticket template
  ticketList: {},
  blockList: [],

  //batch history
  batchHistory: [],
  batchDetail: {},

  //income history
  incomeHistory: [],

  //staff daily income
  staffDailyIncome: null
}
